import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHekmat = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#324C88'
      d='M15.64 3.702c0 2.039-1.625 3.702-3.615 3.702S8.41 5.741 8.41 3.702 10.034 0 12.025 0c1.99 0 3.614 1.663 3.614 3.702M8.36 8.285c0 1.512-1.203 2.745-2.68 2.745C4.204 11.03 3 9.797 3 8.285 3 6.774 4.204 5.54 5.68 5.54s2.68 1.234 2.68 2.745M21 8.336c0 1.512-1.204 2.745-2.68 2.745s-2.68-1.233-2.68-2.745 1.203-2.745 2.68-2.745c1.476 0 2.68 1.233 2.68 2.745M12.025 14.707c1.476 0 2.68-1.233 2.68-2.745s-1.204-2.745-2.68-2.745-2.68 1.233-2.68 2.745 1.203 2.745 2.68 2.745M6.615 16.52c.961 0 1.746-.803 1.746-1.788 0-.984-.785-1.788-1.746-1.788-.962 0-1.746.804-1.746 1.788 0 .985.784 1.788 1.746 1.788M19.205 14.732c0 .985-.784 1.788-1.746 1.788s-1.746-.803-1.746-1.788c0-.984.784-1.788 1.746-1.788s1.746.804 1.746 1.788M12 20.248c.962 0 1.746-.804 1.746-1.788 0-.985-.784-1.788-1.746-1.788s-1.746.803-1.746 1.788c0 .984.784 1.788 1.746 1.788M8.459 21.23a.923.923 0 0 1-.91.932.923.923 0 0 1-.91-.932c0-.514.41-.932.91-.932.501 0 .91.419.91.932M16.574 22.162c.5 0 .91-.42.91-.932a.923.923 0 0 0-.91-.932.923.923 0 0 0-.91.932c0 .513.409.932.91.932M12.96 23.068a.923.923 0 0 1-.91.932.923.923 0 0 1-.91-.932c0-.513.408-.932.91-.932.5 0 .91.419.91.932'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHekmat)
export default ForwardRef
